const routes = {
  root: '/ces-cst/details',
}

export default routes
